var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#93b5ff;}.a{opacity:0.15;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.992.544A.624.624,0,0,0,14.953.39a.026.026,0,0,1,0,0h0a.63.63,0,0,0-.085-.141l-.025-.03a.635.635,0,0,0-.12-.108l0,0a.617.617,0,0,0-.142-.067L14.539.025A.623.623,0,0,0,14.375,0H10a.625.625,0,0,0,0,1.25h2.866L9.136,4.98a5.628,5.628,0,1,0,.884.884L13.75,2.134V5A.625.625,0,0,0,15,5V.625c0-.013,0-.026,0-.038S14.994.558,14.992.544ZM5.625,13.75A4.378,4.378,0,1,1,10,9.375,4.38,4.38,0,0,1,5.625,13.75Z",
    transform: "translate(5 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.d52a1f04b2298daca405a364f8b7728a.svg";
export { ForwardRef as ReactComponent };